import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const LegendContainer = styled.div<IStyledComponentProps>`
  &.legend-container {
    background-color: ${(props) => props.theme.colors.essential.white};
    position: absolute;
    top: 157px;
    z-index: 100;
    left: 20px;
    padding: 8px 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        display: inline;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }

        img {
          margin-top: -1px;
          height: 21px;
        }

        span {
          font-size: ${(props) => props.theme.utils.getFontThemeSize("small")};
          padding-left: 2px;
        }
      }
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      top: 135px;
      left: 10px;
      padding: 8px;
      ul {
        li {
          display: list-item;
          span {
            font-size: ${(props) =>
              props.theme.utils.getFontThemeSize("smallest")};
          }
        }
      }
    }
  }
`;

export default { LegendContainer };
